import React from 'react'
import {KTCard, KTCardBody} from '../../../../_websoft/helpers'

const RadniNaloziDashboard = () => {
    return (
        <KTCard>
            <KTCardBody className='py-6'>
                <div className='container-fluid px-0 px-md-5'>

                    {/* ================= HEADER ================= */}
                    <div className='mb-7'>
                        <h2 className='fw-bolder text-gray-900 mb-1'>
                            Radni nalozi
                        </h2>
                        <div className='text-muted'>
                            Odaberi akciju koju želiš izvršiti.
                        </div>
                    </div>

                    {/* ================= ACTION GRID ================= */}
                    <div className='row g-5'>

                        {/* ================= SPREMI ================= */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='spremi-nalog'
                                className='card shadow-sm border-0 h-100 bg-success'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-5'>

                                    <div className='d-flex align-items-center gap-4'>

                                        <div
                                            className='symbol symbol-60px'
                                            style={{
                                                background:'rgba(255,255,255,0.2)',
                                                borderRadius:'12px'
                                            }}
                                        >
                                            <span className='symbol-label bg-transparent'>
                                                <i className='bi bi-save text-white fs-2x'/>
                                            </span>
                                        </div>

                                        <div>
                                            <div className='text-white fw-bolder fs-2'>
                                                Spremi nalog
                                            </div>

                                            <div className='text-white opacity-75 mt-1'>
                                                Dodijeli Websoft šifre i potvrdi stavke.
                                            </div>
                                        </div>
                                    </div>

                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75'/>
                                </div>
                            </a>
                        </div>
                        {/* ================= TRANSPORT  ================= */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='transport-naloga'
                                className='card shadow-sm border-0 h-100 bg-primary'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-5'>

                                    <div className='d-flex align-items-center gap-4'>

                                        <div
                                            className='symbol symbol-60px'
                                            style={{
                                                background:'rgba(255,255,255,0.2)',
                                                borderRadius:'12px'
                                            }}
                                        >
                                            <span className='symbol-label bg-transparent'>
                                                <i className='bi bi-truck text-white fs-2x'/>
                                            </span>
                                        </div>

                                        <div>
                                            <div className='text-white fw-bolder fs-2'>
                                                Transport
                                            </div>

                                            <div className='text-white opacity-75 mt-1'>
                                                Utovar / Otprema naloga
                                            </div>
                                        </div>
                                    </div>

                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75'/>
                                </div>
                            </a>
                        </div>

                        {/* ================= ISPORUCI ================= */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='isporuci-nalog'
                                className='card shadow-sm border-0 h-100 bg-info'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-5'>

                                    <div className='d-flex align-items-center gap-4'>

                                        <div
                                            className='symbol symbol-60px'
                                            style={{
                                                background:'rgba(255,255,255,0.2)',
                                                borderRadius:'12px'
                                            }}
                                        >
                                            <span className='symbol-label bg-transparent'>
                                                <i className='bi bi-send text-white fs-2x'/>
                                            </span>
                                        </div>

                                        <div>
                                            <div className='text-white fw-bolder fs-2'>
                                                Kontrola / Razduži nalog
                                            </div>

                                            <div className='text-white opacity-75 mt-1'>
                                                Odaberi stavke i potvrdi isporuku.
                                            </div>
                                        </div>
                                    </div>

                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75'/>
                                </div>
                            </a>
                        </div>




                    </div>

                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default RadniNaloziDashboard